import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  emoji: '📗',
  number: 'TOMO 1',
  title: 'EL DESPERTAR',
  subtitle: 'Desayunos, Brunchs y Panificados',
  desc: 'Panqueques de avena, tostadas de palta, revueltos de tofu, panes caseros, licuados y leches vegetales. Arrancá el día con energía real.'
}, {
  emoji: '📘',
  number: 'TOMO 2',
  title: 'EL BANQUETE DIARIO',
  subtitle: 'Almuerzos y Cenas de 20 Minutos',
  desc: 'Bowls de autor, sopas cremosas, platos únicos al horno, salteados express y platos rápidos para los días reales.'
}, {
  emoji: '📙',
  number: 'TOMO 3',
  title: 'EL REY DE LA MESA',
  subtitle: 'Proteínas Vegetales y Texturas Argentinas',
  desc: 'Hamburguesas que no se desarman, milanesas de soja napolitanas, chorizos vegetales, albóndigas de lentejas y el asado vegetal criollo.'
}, {
  emoji: '📕',
  number: 'TOMO 4',
  title: 'EL ALQUIMISTA',
  subtitle: 'Lácteos Vegetales, Quesos y Salsas Cremosas',
  desc: 'Muzza vegana que derrite, queso crema de girasol, dulce de leche vegano, bechamel de avena y mayonesa sin huevo.'
}, {
  emoji: '📓',
  number: 'TOMO 5',
  title: 'CELEBRACIÓN Y PICADAS',
  subtitle: 'Finger Food, Platos de Fiesta y Recetas para Compartir',
  desc: 'Empanadas de pino vegano, choripán vegetal, fugazzeta rellena, hummus de remolacha, pizzas napolitanas y picadas completas.'
}, {
  emoji: '📔',
  number: 'TOMO 6',
  title: 'DULCE FINAL',
  subtitle: 'Repostería Argentina Vegana',
  desc: 'Alfajores de maicena veganos, torta rogel de dulce de leche de coco, brownies de cacao, postre chajá vegano y helado de dulce de leche.'
}];
export function ProductContent() {
  return <section className="bg-[#18181b] py-8 pb-6 px-4" data-id="element-162">
      <div className="max-w-5xl mx-auto" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-165">
            ¿Qué hay adentro del Pack Cocina Veggie?
          </h2>
          <p className="text-lg text-emerald-400 font-medium" data-id="element-166">
            6 Tomos PDF + 6 Bonos — Todo diseñado para Argentina
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-167">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-[#0a0a0a] border border-zinc-800 border-l-4 border-l-emerald-500 rounded-r-lg px-4 py-3 flex items-center gap-3" data-id="element-168">
              <span className="text-xl shrink-0" data-id="element-169">{tomo.emoji}</span>
              <div className="min-w-0" data-id="element-170">
                <span className="text-emerald-500 text-[10px] font-bold tracking-wider" data-id="element-171">
                  {tomo.number}
                </span>
                <h3 className="text-sm font-bold text-white leading-tight" data-id="element-172">
                  {tomo.title}
                </h3>
                <p className="text-zinc-400 text-[11px] leading-snug truncate" data-id="element-173">
                  {tomo.subtitle}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}